import TYPES from '../types'

export const actions = {
  setFilters: (filters) => ({
    type: TYPES.PROSPECT_TABLE.SET_FILTERS,
    filters,
  }),
}
